import ContainerLayout from '@/components/Layout/ContainerLayout'
import HeaderLayout from '@/components/Layout/HeaderLayout'
import { Paper } from '@/components/Paper'
import { useRef, useState } from 'react'
import TabelaPermissoes from './Components/TabelaPermissoes'
import Select from 'react-select';
import { Button, FormLabel, HStack, Input, VStack } from '@chakra-ui/react'
import { api } from '@/services/api';
import { useQuery } from '@tanstack/react-query';
import Header from '../components/Header'
import { BoxTitle } from '@/components/BoxTitle'


export const QueryListToSelect = (url: string) => {

  const { data: list } = useQuery({
    queryKey: ['query-list', url],
    queryFn: () => api.get(url),
    select: (data) =>
      data.data.map(
        (menu: { id: number, nome: string, descricao: string }) => ({
          label: menu.nome || menu.descricao,
          value: menu.id,
          ...menu
        })
      )
  })

  return {
    list
  }
}

const mockPermissions = [
  { id: 1, menu: '10', rota: 'PERMISSÕES', ativo: true },
  { id: 2, menu: '10', rota: 'TIPO DE CARGA', ativo: false },
  { id: 3, menu: '10', rota: 'FORMA DE PAGAMENTO', ativo: true },
  { id: 4, menu: '10', rota: 'FABRICANTE', ativo: true },
  { id: 5, menu: '10', rota: 'MODELO DE VEÍCULO', ativo: true },
  { id: 6, menu: '10', rota: 'TIPO DE COMBUSTÍVEL', ativo: false },
  { id: 7, menu: '10', rota: 'VEÍCULOS', ativo: true },
  { id: 8, menu: '10', rota: 'MOTORISTA', ativo: true },
  { id: 9, menu: '10', rota: 'LOCALIDADE', ativo: false },
  { id: 10, menu: '10', rota: 'TRANSPORTADORA', ativo: true },
];


function Permissoes() {
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');



  const headers = [
    { label: 'Selecionar', key: 'checkbox', isVisible: true },
    { label: 'Menu %', key: 'menu', isVisible: true },
    { label: 'Rota', key: 'rota', isVisible: true },
    { label: 'Ativo', key: 'ativo', isVisible: true },
  ];

  const [visibleHeaders, setVisibleHeaders] = useState(headers);

  const [userToReceived, setUserToReceived] = useState<number>(0);
  const [clonerSelected, setClonerSelected] = useState<number>(0);
  const { list: listUsuario } = QueryListToSelect('usuario/geral');

  const printRef = useRef(null);
  return (
    <>
      <ContainerLayout>
        <HeaderLayout title="Portaria" calendarInput />
        <Paper m={6} bg="white" py={4} px={2} rounded="xl" shadow="sm" border="1px solid rgba(200, 200, 200, .4)">
          <Header
            onHeadersChange={setVisibleHeaders}
            isFilterVisible={isFilterVisible}
            headers={headers}
            isMenuEnabled
            onToggleFilter={() => setIsFilterVisible((prev) => !prev)}
            onView={() => console.log("Visualizar ação executada")}
            printRef={printRef}
            title={'Permissões'}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
          />
          <HStack my={'5'} w={'100%'} >
            <HStack w={'50%'}>
              <BoxTitle title={'Usuário'}>
                <Select
                  aria-label="Selecionador-Usuário"
                  placeholder='Receberá as permissões'
                  onChange={(e) => {
                    //@ts-ignore
                    setUserToReceived(e?.value);
                  }}
                  options={listUsuario}
                  styles={{
                    container: (provided) => ({
                      ...provided,
                      flex: 1,
                    }),
                  }}
                />
              </BoxTitle>
              <BoxTitle title={'Usuário a ser clonado'}>
                <Select
                  aria-label="Selecionador-Usuário"
                  placeholder='A ser clonado'
                  onChange={(e) => {
                    //@ts-ignore
                    setClonerSelected(e?.value);
                  }}
                  options={listUsuario}
                  styles={{
                    container: (provided) => ({
                      ...provided,
                      flex: 1,
                    }),
                  }}
                />
              </BoxTitle>
            </HStack>
            <HStack w={'50%'} justify={'flex-end'}>
              <Button size="md" variant={'outline'} colorScheme="red">
                Remover
              </Button>
              <Button size="md" colorScheme="blue">
                Clonar
              </Button>
            </HStack>
          </HStack>

          <div id="print-content" ref={printRef}>
            <TabelaPermissoes headers={visibleHeaders} dados={mockPermissions} valoPesquisa={searchTerm} />
          </div>
        </Paper>
      </ContainerLayout>
    </>
  )
}

export default Permissoes